import { render, staticRenderFns } from "./HistoryCmp.vue?vue&type=template&id=3d2b527e&scoped=true"
import script from "./HistoryCmp.vue?vue&type=script&lang=js"
export * from "./HistoryCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b527e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2b527e')) {
      api.createRecord('3d2b527e', component.options)
    } else {
      api.reload('3d2b527e', component.options)
    }
    module.hot.accept("./HistoryCmp.vue?vue&type=template&id=3d2b527e&scoped=true", function () {
      api.rerender('3d2b527e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Edit/HistoryCmp.vue"
export default component.exports